var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Modal',{attrs:{"title":"","description":""},on:{"openModalAdd":_vm.openModalAdd,"closeModalAdd":_vm.closeModalAdd}},[_c('img',{staticClass:"w-full rounded-DEFAULT",attrs:{"src":_vm.image}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }